// extracted by mini-css-extract-plugin
module.exports = {"story-page-wrapper":"story-m__story-page-wrapper__1wYx-"};